import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
// import { Trans, useTranslation } from 'react-i18next';
import '../../stylesheets/products.css'

export default function Footer() {

  const { t } = useTranslation();

  return (
    <div style={{
      textAlign: 'center',
      height: "var(--dimenFooterHeight)",
      padding: "50px",

    }}>
      <p className='link1'>
        {t("footer")}
        <a className='linkk' href="https://div-systems.com/" target="_blank" rel="noreferrer"> Div Systems.</a>
      </p>
    </div>
  );
}
